import { DBMSType } from '@/enums';
import { CdmDataSourceDTO, DBMSTypesDTO } from '@/types';
import {
  GetListType,
  GetByIdType,
  RemoveByIdType,
  UpdateByIdType,
  CreateEntityType,
  UpsertEntityType,
  GetFiltersType,
  GetSortingType,
} from '@prometheus/types';
import { api, getSortDirection } from '@prometheus/utils';

export const getCdmDataSourcesList: GetListType<CdmDataSourceDTO> =
  searchParams => {
    const { pageNumber, pageSize, sortBy, query } = searchParams;
    const sort = getSortDirection(sortBy);
    const url =
      `/data-sources/list?size=${pageSize || ''}` +
      `&page=${pageNumber || ''}` +
      `&sort=${sort}` +
      `&${query || ''}`;
    return api.get(url);
  };

//---FILTERS--------------------------------------------------------------
export const getCdmDataSourcesListFilters: GetFiltersType = options => {
  const url = `/data-sources/filter?${options}`;
  return api.get(url);
};

export const getDbmsTypes = (): Promise<DBMSTypesDTO> => {
  return api.get('/data-sources/dbms-types');
};

export const getSorting: GetSortingType = () => {
  return api.get('/data-sources/sorts');
};

//---GET BY ID-----------------------------------------------------
export const getDataSource: GetByIdType<any> = id =>
  api.get(`/data-sources/${id}`);

//---REMOVE BY ID-----------------------------------------------------
export const removeDataSource: RemoveByIdType = id =>
  api.delete(`/data-sources/${id}`);

//---UPDATE BY ID------------------------------
export const updateDataSource = (data: any, id: string): Promise<any> =>
  api.put(`/data-sources/${id}`, data);

//---CREATE-----------------------------------------------
export const createDataSource: CreateEntityType<any> = data =>
  api.post(`/data-sources`, data);

//---UPSERT------------------------------
export const upsertDataSource: UpsertEntityType<any> = (
  data: any,
  id: string
) => {
  if (id !== 'new') {
    return updateDataSource(data, id);
  } else {
    return createDataSource(data);
  }
};

export const getListCentralHosts = (): Promise<any> => {
  return api.get(`/datanode/centrals/list`);
};

export const publishDataSource = (
  dataSourceId: string,
  data: any
): Promise<any> => {
  return api.post(`/data-sources/${dataSourceId}/publish`, data);
};

export const createDataSourceExecution = (
  dataSourceId: string,
  data: {
    cdmVersion: string;
    createCdmSchema: boolean;
    createResultsSchema: boolean;
  }
): Promise<any> => api.post(`/data-sources/${dataSourceId}/executions`, data);

export const getDataSourceExecutions =
  (dataSourceId: string) =>
  (searchParams: any): Promise<any> => {
    const { pageNumber, pageSize, sortBy } = searchParams;
    const sort = getSortDirection(sortBy);
    return api.get(
      `/data-sources/${dataSourceId}/executions/list?size=${pageSize || ''}` +
        `&page=${pageNumber || ''}` +
        `&sort=${sort}`
    );
  };
export const getDataSourceExecutionById = (
  dataSourceId: string,
  executionId: string
): Promise<any> =>
  api.get(`/data-sources/${dataSourceId}/executions/${executionId}`);

export const isConfigurationAllowed = (
  dataSourceId: string
): Promise<{
  allowed: boolean;
}> => {
  return api
    .get(`/data-sources/${dataSourceId}/executions/allowed`)
    .catch(err => ({
      allowed: true,
    }));
};
